import createDispatchAction, { AppThunk } from './base.action'

interface keyValue {
    key: string
    value: string
}

export const SET_BREADCRUMB_MAPPING = 'SET_BREADCRUMB_MAPPING'
export const SET_IGNORE_WORDS = 'SET_IGNORE_WORDS'

export const setBreadCrumbMapping = (payload: keyValue): AppThunk => (
    dispatch,
) => dispatch(createDispatchAction(SET_BREADCRUMB_MAPPING, payload))

export const ignorePaths = (words: string[]): AppThunk => (dispatch) =>
    dispatch(createDispatchAction(SET_IGNORE_WORDS, words))
